var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleAuthen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.829 2.34383L5.60501 4.67499C4.4168 5.12764 3.4436 6.53086 3.4436 7.8096V16.9758C3.4436 17.8924 4.04337 19.1033 4.77893 19.6464L11.0029 24.2974C12.1006 25.1235 13.8999 25.1235 14.9975 24.2974L21.2215 19.6464C21.957 19.0919 22.5568 17.8924 22.5568 16.9758V7.8096C22.5568 6.54218 21.5836 5.12764 20.3954 4.6863L14.1714 2.35515C13.5377 2.10619 12.474 2.10619 11.829 2.34383Z",
    fill: "#0A5AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6498 11.2942V10.5836C16.6498 9.67843 16.6498 6.93359 12.9998 6.93359C9.34974 6.93359 9.34974 9.67843 9.34974 10.5836V11.2942C8.16226 11.557 7.76318 12.3259 7.76318 13.9903V14.9637C7.76318 17.105 8.42506 17.7669 10.5664 17.7669H15.4331C17.5745 17.7669 18.2364 17.105 18.2364 14.9637V13.9903C18.2364 12.3259 17.8373 11.557 16.6498 11.2942ZM15.1898 11.1871H10.8098V10.5836C10.8098 9.16255 11.1602 8.39361 12.9998 8.39361C14.8394 8.39361 15.1898 9.16255 15.1898 10.5836V11.1871Z",
    fill: "#0A5AF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleAuthen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-authen.2841c6545b9c8e54d337a40e1829373a.svg";